import { orderBy } from 'lodash-es'

import { Switch } from '@/components/ui/switch'
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table'

export interface ListMetrics {
  id: number
  listName: string
  source?: string
  isActive: boolean
  totalContacts: number
  contactsInQueue: number
}

interface CampaignContactListsProps {
  contactLists: ListMetrics[]
  onToggleContactListItem: (listId: number, newStatus: boolean) => void
  disabled?: boolean
}

export function CampaignContactLists({
  contactLists,
  onToggleContactListItem,
  disabled,
}: CampaignContactListsProps) {
  const handleToggle = async (listId: number, newStatus: boolean) => {
    await onToggleContactListItem(listId, newStatus)
  }

  if (contactLists.length === 0) {
    return (
      <div className="text-center py-2">
        <p className="text-muted-foreground text-body">No contact lists attached</p>
      </div>
    )
  }

  const sortedContactLists = orderBy(contactLists, ['id'], ['desc'])

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[50px] text-center">ID</TableHead>
          <TableHead>List Name</TableHead>
          <TableHead className="w-[90px] text-center">Total</TableHead>
          <TableHead className="w-[100px] text-center">In Queue</TableHead>
          <TableHead className="w-[80px] text-center">Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedContactLists.map((list: ListMetrics) => (
          <TableRow key={list.id}>
            <TableCell className="font-medium text-center">{list.id}</TableCell>
            <TableCell className="font-medium">
              {list.listName}
              {list.source && <p className="text-detail text-muted-foreground mt-1">{list.source}</p>}
            </TableCell>
            <TableCell className="text-center">{list.totalContacts?.toLocaleString()}</TableCell>
            <TableCell className="text-center">{list.contactsInQueue?.toLocaleString()}</TableCell>
            <TableCell className="text-center">
              <div className="flex items-center justify-center">
                <Switch
                  checked={list.isActive}
                  onCheckedChange={(checked) => handleToggle(list.id, checked)}
                  disabled={disabled}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
